
import React from 'react'
import {Backdrop, CircularProgress} from "@mui/material";



const BackDrop = (props) => {
    return (
        //This code causes warning, will be fixed in v5 material ui.
        // details: https://stackoverflow.com/questions/61220424/material-ui-drawer-finddomnode-is-deprecated-in-strictmode
        <React.Fragment>
            <Backdrop open={props.open}>
                <CircularProgress color="inherit"/>
            </Backdrop>
            {props.children}
        </React.Fragment>
    )
}

export default BackDrop

